import AllSportsMenu from './all-sports-menu';

export default AllSportsMenu;
